function r(r,...e){const o=new URL(`https://mui.com/production-error/?code=${r}`);return e.forEach((r=>o.searchParams.append("args[]",r))),`Minified MUI error #${r}; visit ${o} for the full message.`}export{r as default};
//# sourceMappingURL=formatMuiErrorMessage.js.map
